/* LOVE BOMB — roll the dice.

   The two cubes used to share one CSS keyframe, so every roll was the same
   roll and both dice moved as a single object — the thing that made them read
   as a graphic rather than as dice. Each throw is now built per die with the
   Web Animations API: its own number of whole turns, its own airtime, its own
   wobble, and a landing that bounces twice with the height falling away each
   time. The CSS keyframe is kept as a fallback where .animate() is missing. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var canAnimate = typeof Element !== 'undefined' && !!Element.prototype.animate;

  function list(el, attr) {
    return (el.getAttribute(attr) || '')
      .split(',')
      .map(function (t) {
        return t.trim();
      })
      .filter(Boolean);
  }

  function num(el, attr, fallback) {
    var v = parseFloat(el.getAttribute(attr));
    return isNaN(v) ? fallback : v;
  }

  function rand(min, max) {
    return min + Math.random() * (max - min);
  }

  function frame(y, rx, ry, rz, scale) {
    return (
      'translateY(' + y + '%) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) rotateZ(' + rz + 'deg) scale(' + scale + ')'
    );
  }

  /* One throw. Returns the cube's animation so the caller can wait on it. */
  function throwDie(die, cfg) {
    var cube = die.querySelector('.lb-dice__cube');
    var shadow = die.querySelector('.lb-dice__shadow');
    if (!cube) return null;

    var restX = cfg.restX;
    var restY = cfg.restY;

    /* Whole turns only, so the die lands square on the face it started from —
       a fractional spin is what made the old roll snap at the end. */
    var turnsX = Math.round(rand(2, 4));
    var turnsY = Math.round(rand(2, 5));
    // half the time it tumbles the other way
    var dirX = Math.random() < 0.5 ? -1 : 1;
    var dirY = Math.random() < 0.5 ? -1 : 1;
    var spinX = dirX * 360 * turnsX;
    var spinY = dirY * 360 * turnsY;
    // a little roll about the viewing axis, gone by the time it lands
    var wobble = rand(-16, 16);

    var lift = cfg.bounce;
    // each landing takes the height down sharply, the way a real die dies out
    var b2 = lift * 0.3;
    var b3 = lift * 0.09;

    var cubeFrames = [
      { offset: 0, transform: frame(0, restX, restY, 0, 1), easing: 'cubic-bezier(0.15, 0.6, 0.4, 1)' },
      { offset: 0.3, transform: frame(-lift, restX + spinX * 0.42, restY + spinY * 0.42, wobble, 0.95), easing: 'cubic-bezier(0.55, 0, 0.85, 0.5)' },
      // first landing — a touch of squash as it hits
      { offset: 0.56, transform: frame(0, restX + spinX * 0.78, restY + spinY * 0.78, wobble * 0.4, 1.04), easing: 'cubic-bezier(0.2, 0.7, 0.4, 1)' },
      { offset: 0.71, transform: frame(-b2, restX + spinX * 0.9, restY + spinY * 0.9, wobble * 0.15, 0.99), easing: 'cubic-bezier(0.55, 0, 0.85, 0.5)' },
      { offset: 0.85, transform: frame(0, restX + spinX * 0.97, restY + spinY * 0.97, 0, 1.02), easing: 'cubic-bezier(0.2, 0.7, 0.4, 1)' },
      { offset: 0.94, transform: frame(-b3, restX + spinX * 0.99, restY + spinY * 0.99, 0, 1) },
      { offset: 1, transform: frame(0, restX + spinX, restY + spinY, 0, 1) },
    ];

    /* The shadow reads the height: tight and faint at the top of the throw,
       spread and solid on each landing. */
    var shadowFrames = [
      { offset: 0, transform: 'translateX(-52%) scale(1)', opacity: 1 },
      { offset: 0.3, transform: 'translateX(-52%) scale(0.55)', opacity: 0.32 },
      { offset: 0.56, transform: 'translateX(-52%) scale(1.1)', opacity: 1 },
      { offset: 0.71, transform: 'translateX(-52%) scale(0.8)', opacity: 0.68 },
      { offset: 0.85, transform: 'translateX(-52%) scale(1.05)', opacity: 1 },
      { offset: 0.94, transform: 'translateX(-52%) scale(0.94)', opacity: 0.9 },
      { offset: 1, transform: 'translateX(-52%) scale(1)', opacity: 1 },
    ];

    var timing = { duration: cfg.duration, delay: cfg.delay, easing: 'linear', fill: 'none' };

    if (shadow) shadow.animate(shadowFrames, timing);
    return cube.animate(cubeFrames, timing);
  }

  function setup(root) {
    var btn = root.querySelector('[data-lb-dice-roll]');
    var out = root.querySelector('[data-lb-dice-result]');
    var dieA = root.querySelector('[data-die="a"]');
    var dieB = root.querySelector('[data-die="b"]');
    if (!btn || !dieA || !dieB) return;

    var wordsA = list(root, 'data-words-a');
    var wordsB = list(root, 'data-words-b');
    if (!wordsA.length || !wordsB.length) return;

    var tpl = root.getAttribute('data-template') || '[a] / [b]';
    var baseMs = num(root, 'data-roll-ms', 950);
    var bounce = num(root, 'data-roll-bounce', 36);
    var restX = num(root, 'data-rest-x', -18);
    var restY = num(root, 'data-rest-y', -26);
    var randomise = root.getAttribute('data-roll-random') !== 'false';

    var busy = false;
    // remember the last pick per die so a roll always visibly changes
    var lastA = -1;
    var lastB = -1;

    function pick(words, last) {
      if (words.length < 2) return 0;
      var i;
      do {
        i = Math.floor(Math.random() * words.length);
      } while (i === last);
      return i;
    }

    /* Per-die settings. Without the jitter the two cubes start, peak and land
       on the same frame, which is what made them look welded together. */
    function config() {
      if (!randomise) return { duration: baseMs, delay: 0, bounce: bounce, restX: restX, restY: restY };
      return {
        duration: baseMs * rand(0.85, 1.18),
        delay: rand(0, 110),
        bounce: bounce * rand(0.82, 1.18),
        restX: restX,
        restY: restY,
      };
    }

    function roll() {
      if (busy) return;
      busy = true;

      var ia = pick(wordsA, lastA);
      var ib = pick(wordsB, lastB);
      lastA = ia;
      lastB = ib;

      var slotA = dieA.querySelector('[data-word]');
      var slotB = dieB.querySelector('[data-word]');

      function land() {
        slotA.textContent = wordsA[ia];
        slotB.textContent = wordsB[ib];
        dieA.classList.remove('is-rolling', 'is-rolling-css');
        dieB.classList.remove('is-rolling', 'is-rolling-css');
        if (out) out.textContent = tpl.replace('[a]', wordsA[ia]).replace('[b]', wordsB[ib]);
        busy = false;
      }

      if (reduce.matches || !canAnimate) {
        if (reduce.matches) {
          land();
          return;
        }
        // no Web Animations API — fall back to the fixed CSS keyframe
        dieA.classList.add('is-rolling', 'is-rolling-css');
        dieB.classList.add('is-rolling', 'is-rolling-css');
        setTimeout(function () {
          slotA.textContent = wordsA[ia];
          slotB.textContent = wordsB[ib];
        }, 320);
        setTimeout(land, 720);
        return;
      }

      dieA.classList.add('is-rolling');
      dieB.classList.add('is-rolling');

      var cfgA = config();
      var cfgB = config();
      var animA = throwDie(dieA, cfgA);
      var animB = throwDie(dieB, cfgB);

      /* The face is hidden through the tumble, so the new word goes in while
         it is out of sight — each die on its own clock, since they no longer
         share a duration. */
      setTimeout(function () {
        slotA.textContent = wordsA[ia];
      }, cfgA.delay + cfgA.duration * 0.4);
      setTimeout(function () {
        slotB.textContent = wordsB[ib];
      }, cfgB.delay + cfgB.duration * 0.4);

      var done = 0;
      var total = (animA ? 1 : 0) + (animB ? 1 : 0);
      if (!total) {
        land();
        return;
      }

      function step() {
        done += 1;
        if (done >= total) land();
      }

      if (animA) animA.onfinish = step;
      if (animB) animB.onfinish = step;

      // belt and braces: never leave the dice stuck mid-roll
      setTimeout(function () {
        if (busy) land();
      }, Math.max(cfgA.delay + cfgA.duration, cfgB.delay + cfgB.duration) + 240);
    }

    btn.addEventListener('click', roll);

    // the dice themselves are the obvious thing to tap
    [dieA, dieB].forEach(function (d) {
      d.addEventListener('click', roll);
      d.style.cursor = 'pointer';
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-lb-dice]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
